import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/about/")({
	loader: async ({ context: { serviceLocator }, preload }) => {
		if (!preload) {
			serviceLocator.get("loggerService").logEvent("about page view");
		}
	},
});
